module.exports = __webpack_public_path__ + "img/Tobb_Logo.52b682b0.svg";